<template>
  <div class="bbp-select-cell" :style="style">
    <BBPSelect :options="options"
               :placeholder="placeholder"
               :label="label"
               :value="value"
               @change="setValue"/>
  </div>
</template>

<script>
import {get, isEqual} from 'lodash'
import BBPSelect from '@/components/Main/InputFields/BBPSelect/BBPSelect'

export default {
  name: 'BBPSelectCell',
  components: {BBPSelect},
  props: ['row', 'column', 'index'],
  computed: {
    options () {
      return get(this.column, 'options', [])
    },
    label () {
      return get(this.column, 'listLabel', 'name')
    },
    value () {
      return get(this.row, this.column.prop, '')
    },
    placeholder () {
      return get(this.column, 'placeholder', '')
    },
    style () {
      const minWidth = get(this.column, 'selectWidth.min', 'auto')
      const maxWidth = get(this.column, 'selectWidth.max', 'auto')
      return {
        minWidth,
        maxWidth
      }
    }
  },
  methods: {
    setValue (val) {
      const noChange = isEqual(this.value, val)
      if (noChange) return
      this.$emit('update', {row: this.row, column: this.column, value: val})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-select-cell {
    @include global-font;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: -4px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPSelectCell/BBPSelectCell.vue